import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SettingsLayout } from '@/components/layouts/settings-layout'
import { InputField } from '@/components/molecules/input-field'
import { DeviceSettingsFooter } from '@/components/organisms/settings/device-settings-footer'
import { CheckinTabContainer } from '@/components/organisms/settings/checkin-tab-container'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { AccountContext } from '@/contexts/account'
import { useCashChangerSetting } from '@/hooks/self-checkin-device-settings/use-cash-changer-setting'

export const SelfCheckinCashChanger: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useContext<any>(AccountContext)
  const hotelId: string = account?.hotel?.id || account?.employee?.hotelId || ''
  const { control, isDirty, isLoading, canTestConnection, testConnection, save, cancel } = useCashChangerSetting(hotelId)
  const footerContent = (
    <DeviceSettingsFooter isDirty={isDirty} onSave={save} onCancel={cancel} onTest={testConnection} isTestDisabled={!canTestConnection} />
  )

  return (
    <SettingsLayout loading={isLoading} footerContent={footerContent}>
      <TabContainer tabComponent={<CheckinTabContainer currentTab="CashChanger" />} isShowFooter>
        <div css={containerStyle}>
          <div css={fieldStyle}>
            <div className="input-label">{t('SB-H50 serial number')}</div>
            <Controller
              control={control}
              name="cashChangerSerialNumber"
              render={({ field: { onChange, value } }) => <InputField value={value} handleChangeData={onChange} placeholder="XXXX000001" />}
            />
          </div>
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const containerStyle = css({
  padding: 32,
  '.input-label': {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 12,
  },
})

const fieldStyle = css({ width: 300 })
